import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data?.pageIndex,
            page_size: data?.pageSize,
            is_addon: data?.addon,
        }
        if (data?.sort) {
            data?.sort?.map(sort => {
                if (!sort.dir) return sort
                datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
                return sort
            })
        }
        if (data?.query) {
            datas.search = data.query
        }
        if (data?.selectedTab) {
            datas.status = data.selectedTab
        }
        if (Array.isArray(data.branch) && data.branch.length) {
            datas.branch = data.branch.join(',')
        }
        if (data.company) {
            datas.company = data.company
        }
        if (data.status) {
            datas.status = data.status
        }
    }
    return ApiService.get('/product/products/', datas).then(res => {
        return res
    })
}
export const createApiRecord = data => ApiService.post('/product/products/', data)
export const getApiRecord = id => ApiService.get(`/product/products/${id}`)
export const updateApiRecord = (id, data) => ApiService.put(`/product/products/${id}/`, data)
export const updateApiStatus = (id, data) => ApiService.patch(`/product/products/${id}/`, data)
export const assignAddonApi = data => ApiService.post(`/product/addons/`, data)
export const attachImagesApi = data => ApiService.post(`/product/product-images/`, data)
export const updateProductImageApi = (id, data) => ApiService.put(`/product/product-images/${id}/`, data)
export const deleteProductImageApi = id => ApiService.delete(`/product/product-images/${id}/`)
export const reorderProductImagesApi = (productId, imageIds) => ApiService.patch(`/product/products/${productId}/reorder-images/`, { image_order: imageIds })
